<template>
  <div>
    <h1 class="display-4">Liste des paramètres</h1>
    <hr />

    <b-table class="mt-3" :dark="theme == 'dark'" responsive hover striped :items="schools" :fields="fields" :current-page="currentPage" :per-page="perPage" v-show="totalRows > 0">
      <template slot="actions" slot-scope="cell">
        <router-link tag="a" class="btn btn-sm btn-primary" :to="{ name: 'ParameterEditExist', params: {id: cell.item.id } }">
          Editer
        </router-link>
      </template>
    </b-table>

    <b-row v-show="totalRows > perPage">
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

    <p class="text-center" v-show="totalRows == 0"><em>Il y a aucun paramètre pour le moment...</em></p>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)

export default {
  data () {
    return {
      currentPage: 1,
      fields: {
        name: {
          label: 'Nom',
          sortable: false
        },
        actions: {
          label: 'Actions',
          key: 'actions'
        }
      },
      parameters: [],
      perPage: 20
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'schools', 'theme']),
    totalRows () {
      return this.schools.length
    }
  },
  mounted () {
    // console.log(this.schools.length)
    // for (let i = 0; i < this.schools.length; i++) {
    //   if (this.parameters.indexOf(this.schools[i].id) > -1) {
    //     this.parameters.push(this.schools[i])
    //   }
    // }
    // this.$http.get(this.domain + '/api/schools?access_token=' + this.access_token + '&filter[order]=name ASC').then((response) => {
    //   response.json().then((data) => {
    //     // this.parameters = data
    //     for (let i = 0; i < data.length; i++) {
    //       if (this.schools.indexOf(data[i].id) > -1) {
    //         this.parameters.push(data[i])
    //       }
    //     }
    //   })
    // }, (response) => {

    // })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Parameters/List.vue